var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMarker',{key:_vm.markerKey,ref:"dashMarker",attrs:{"position":_vm.coords,"clickable":_vm.visible,"visible":_vm.visible,"icon":{
    url: require(`@/assets/img/marker-${_vm.vehicleStatus}.svg`)
  }},on:{"click":_vm.setCenter}})
}
var staticRenderFns = []

export { render, staticRenderFns }